/* eslint-disable sort-keys-fix/sort-keys-fix */
const SectionInfoFields = {
    participant: {
        FIRST_NAME: "accountFirstName",
        LAST_NAME: "accountLastName",
        INFIX: "accountInfix",
        EMAIL: "accountHasRoleEmail",
        LANGUAGE: "accountHasRoleLanguage",
        GENDER: "accountGender",
        DEMO: "isDemoParticipant",
        PHONE: "livePhoneNumber",
    },
    mappedParticipantFields: {
        accountFirstName: "firstName",
        accountLastName: "lastName",
        accountInfix: "infix",
        accountHasRoleEmail: "email",
    },
};

export default SectionInfoFields;
